import React from "react";
import { useEffect } from "react";
import "aos/dist/aos.css"; // Import the AOS styles
import AOS from "aos";

export default function Skills() {
  useEffect(() => {
    AOS.init(); // Initialize AOS
    AOS.refresh(); // Refresh AOS to detect new elements

    return () => {
      AOS.refreshHard(); // Cleanup AOS on component unmount
    };
  }, []);

  const SetIcon = ({ src, Heading }) => {
    return (
      <>
        <div
          data-aos="zoom-in-up"
          className="inset-20 shadow-[#dc143c_5px_3px_4px_0px] grid grid-cols-1 items-center vs:p-2 md:p-4 w-28 h-fit bg-white rounded-lg vs:mt-5 m-auto font-space font-semibold hover:shadow-lg"
        >
          <img src={src} alt="Skill" />
          <p className="pt-2">{Heading}</p>
        </div>
      </>
    );
  };

  return (
    <>
      <div
        className="md:min-h-screen max-h-fit h-max md:p-28 md:pt-12 vs:py-10 ts:p-20 bg-gray-light grid justify-center text-center dark:bg-[#001840]"
        id="SKILLS"
      >
        <h1 className="text-center vs:text-2xl ts:text-4xl md:mb-5 font-Ubuntu font-semibold dark:text-white">
          My{" "}
          <span className=" border-b-4 border-common-red text-common-red ">
            Technical
          </span>{" "}
          Skills
        </h1>
        <div className="grid ts:grid-cols-4 md:grid-cols-7 justify-center ts:gap-10 grid-cols-2 gap-5 md:gap-12 my-10">
          <SetIcon src="./svgs/HTML_icon.svg" Heading="HTML" />
          <SetIcon src="./svgs/CSS-icon.svg" Heading="CSS" />
          <SetIcon src="./svgs/JAVASCRIPT-icon.svg" Heading="JavaScript" />
          <SetIcon src="/Images/TypeScript.webp" Heading="TypeScript" />
          <SetIcon src="/svgs/python.svg" Heading="Python" />
          <SetIcon src="./svgs/REACT-icon.svg" Heading="React" />
          <SetIcon src="/svgs/Redux.svg" Heading="Redux" />
          <SetIcon src="/Images/NextJS.png" Heading="NextJS" />
          {/* <SetIcon src="/Images/prisma.png" Heading="Prisma" /> */}
          <SetIcon src="/svgs/NodeJS.svg" Heading="Node JS" />
          <SetIcon src="/svgs/express.svg" Heading="Express" />
          <SetIcon src="/Images/NESTJS.png" Heading="NestJS" />
          <SetIcon src="/svgs/mongodb.svg" Heading="MongoDB" />
          <SetIcon src="/Images/PostgreSQL.png" Heading="PostgreSQL" />
          <SetIcon src="/Images/mongoose.png" Heading="Mongoose" />
          <SetIcon src="/Images/chakra-ui.png" Heading="Chakra-UI" />
          <SetIcon src="./svgs/TAILWIND_CSS-icon.svg" Heading="Tailwind" />
          <SetIcon src="./svgs/BOOTSTRAPT-icon.svg" Heading="BootStrap" />
          {/* <SetIcon src="/Images/sanity.io.png" Heading="Sanity.io" /> */}
          <SetIcon src="/Images/VSCODE.png" Heading="VSCODE" />
          <SetIcon src="/svgs/git.svg" Heading="Git" />
          <SetIcon src="/Images/postman.png" Heading="Postman" />
          <SetIcon src="/Images/docker.png" Heading="Docker" />
        </div>
      </div>
    </>
  );
}
